import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with interceptor for token-based auth
const api = axios.create({
  baseURL: `${API_BASE}/api`,
});

// Add token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 responses (token expired/invalid)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
    }
    return Promise.reject(error);
  }
);

// Auth functions
export const checkAuth = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('auth_token');
  window.location.href = '/';
};

export const getLoginUrl = () => {
  return `${API_BASE}/api/auth/discord/login`;
};

export const saveToken = (token) => {
  localStorage.setItem('auth_token', token);
};

export const getToken = () => {
  return localStorage.getItem('auth_token');
};

export default api;
